// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./logo_image.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: lato, sans-serif;
  font-size: 15px;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px;
}

.App-header {
  background-color: #222;
  height: 80px;
  padding: 20px;
  color: white;
}

.App-intro {
  font-size: large;
}

.tankDemo h1 {
  margin-left: 10px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.Tank {
  height: 15px;
}

.Building {
  height: 30px;
}

.query {
  margin: 20px;
}

.inProcess {
  margin-left: 65px;
  margin-top: 20px;
  color: blue;
}

.completed {
  margin-left: 20px;
}

.query input {
  width: 55%;
}

.query .key {
  width: 100px;
}

.query button {
  margin-left: 10px;
}

.question {
  background: red;
}

.help {
  margin: 20px;
}

.blink {
    animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.5;
  }
}

.world {
  height: 280px;
  border-style: solid;
  margin: 20px;
  background: lightgreen;
}

.foodOrders {
  height: 280px;
  border-style: solid;
  margin: 20px;
  background: lightblue;
}

@keyframes App-logo-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.layout {
  background-color: whitesmoke;
}

.about {
  padding-top: 25px;
  padding-left: 25px;
}

.about {
  .line {
    line-height: 1.5em;
    .label {
      font-weight: bold;
    }
  }
}

.logo {
  padding-top: 1px;
  padding-bottom: 4px;
  text-align: center;
  font-size: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border-top-style: solid;
  border-bottom-style: double;
}

.tutorial h1 {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  border-top-style: solid;
  border-bottom-style: double;
  color: black;
  text-shadow: -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF;
}

.tutorial h1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0px 550px;
}

.videos {
  padding-left: 50px;
  padding-right: 50px;
}

.videos .header {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0px 550px;
}

.videos a { 
  display: block;
}

.videos h1 {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  border-top-style: solid;
  border-bottom-style: double;
  color: black;
  text-shadow: -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF;
}

.logo .name {
  display: inline;
  padding: 10px;
  width: 500px;
  font-weight: bold;
}

.logo .motto {
  display: inline;
  font-size: 5px;
}

.bar {
  line-height: 27px;
  width: 100%;
}

.barItem {
  display: inline;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  color: rbg(119,119,119);
  outline-color: rbg(119,119,119);
  text-decoration-color: rbg(119,119,119);
}

.barItem:hover {
  background-color: lightgrey;
}

.subMenuItem {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 8px;
  padding-bottom: 8px;
  color: rbg(119,119,119);
  outline-color: rbg(119,119,119);
  text-decoration-color: rbg(119,119,119);
}

.subMenuItem:hover {
  background-color: lightgrey;
}

.credentials {
  font-size: 15px;
  border-style: solid;
  border-width: 1px;
  padding: 6px;
  margin-left: 10px;
}

.configProps {
  padding-left: 3px;
}

#server {
  width: 200px;
}

.product {
  text-align: center;
}

.product .name {
  margin-top: 50px;
  line-height: 45px;
  font-size: 35px;
  font-weight: bold;
}

.product .brief {
  font-style: italic;
  font-size: 10px;
}

.product .details {
  text-align: center;
  padding-left: 200px;
  padding-right: 200px;
}

.demo {
  margin-left: 10px;
}

.product code {
  font-family: courier;
  display: block;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 5px;
}

code {
  font-family: courier;
  display: block;
  padding-left: 100px;
  display: table;
}

#contact-form {
  align: center;
  float: left;
  display: inline-block;
}

#contact-form label {
  width: 200px;
}

.form-control {
  display: inline-block;
  width: 500px;
}

.form-control .message {
  height: 500px;
}

.quote {
  font-family: courier;
  font-size: 15px;
}

pre {
  margin-left: 100px;
  margin-right: 100px;
  background-color: lightgray;
}

.tutorial {
  padding-left: 50px;
  padding-right: 50px;
}

.purchase {
  padding-left: 50px;
  padding-right: 50px;
}

.purchase p {
  padding-left: 20px;
}

table, th, td {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  border: 1px solid black;
}

.subscriptions {
  padding-left: 50px;
  padding-right: 50px;
}

.subscriptions .line {
  margin-top: 10px;
}

.subscriptions .label {
  font-weight: bold;
}

.subscriptions .value {
  border: 1px solid black;
  margin-left: 10px;
  padding: 2px;
}

.config {
  padding-left: 50px;
  padding-right: 50px;
}

form {
  padding-top: 20px;
  padding-left: 20px;
}

.form-group {
  padding-top: 5px;
}

.form-control {
  margin-left: 10px;
}

.subscriptions .buttons {
  margin-top: 20px;
}

.subscriptions .buttons Button {
  margin-left: 5px;
}

.menuBar {
  margin-top: 10px;
  margin-bottom: 10px;
}

.config {
  margin-top: 20px;
  padding-left: 20px;
  font-family: courier, sans-serif;
  font-size: 15px;
  white-space: pre;
}

.controlServer {
  margin-top: 10px;
  border-style: solid;
  padding: 10px;
}

.productListing {
  margin-top: 10px;
  border-style: solid;
  padding: 5px;
}

.submitBug {
  border: 1px solid black;
}

.moduleSource {
  border: 1px solid black;
  font-size: 15px;
  margin-left: 10px;
  padding: 5px;
  padding-bottom: 7px;
}

.moduleSource a {
  margin: 5px;
}

.includes {
  border-style: solid;
  border-width: 1px;
  margin-left: 10px;
  padding: 5px;
  padding-bottom: 7px;
  font-size: 15px;
}

.includes .selected {
  margin-left: 5px;
  font-weight: bold;
}

.caret {
  width: 0;
  height: 0;
  display: inline-block;
  border: 10px solid transparent;
}

.caret.down{
  border-top-color: black;
  margin-left: 10px;
}

.caret.right {
  border-left-color: black;
  margin-left: 10px;
}

.deployVersion button {
  margin-top: 10px;
}

.deployVersion a {
  margin-left: 10px;
}

.deploymentPaused {
  margin-left: 10px;
}

.youtubeLink {
  margin-left: 10px;
}

.purchaseVideo a {
  margin-top: 10px;
  margin-right: 5px;
  margin-bottom: 30px;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  margin-right: 10px;
  display: inline-block;
  padding: 3px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.section {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  font-size: large;
}

.kms {
  padding-left: 50px;
  padding-right: 50px;
}

.km {
  padding-left: 20px;
}

.kmIncludes {
  margin-left: 40px;
}

.kmUtterances {
  margin-left: 40px;
}

.kmInitial {
  margin-left: 40px;
}

.kmName {
  font-weight: bold;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: lightgreen;
  color: white;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB;MACE,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yDAAyC;EACzC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,+EAA+E;AACjF;;AAEA;EACE,yDAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yDAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n  font-family: lato, sans-serif;\n  font-size: 15px;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px;\n}\n\n.App-header {\n  background-color: #222;\n  height: 80px;\n  padding: 20px;\n  color: white;\n}\n\n.App-intro {\n  font-size: large;\n}\n\n.tankDemo h1 {\n  margin-left: 10px;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.Tank {\n  height: 15px;\n}\n\n.Building {\n  height: 30px;\n}\n\n.query {\n  margin: 20px;\n}\n\n.inProcess {\n  margin-left: 65px;\n  margin-top: 20px;\n  color: blue;\n}\n\n.completed {\n  margin-left: 20px;\n}\n\n.query input {\n  width: 55%;\n}\n\n.query .key {\n  width: 100px;\n}\n\n.query button {\n  margin-left: 10px;\n}\n\n.question {\n  background: red;\n}\n\n.help {\n  margin: 20px;\n}\n\n.blink {\n    animation: blinker 2s linear infinite;\n}\n\n@keyframes blinker {\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.world {\n  height: 280px;\n  border-style: solid;\n  margin: 20px;\n  background: lightgreen;\n}\n\n.foodOrders {\n  height: 280px;\n  border-style: solid;\n  margin: 20px;\n  background: lightblue;\n}\n\n@keyframes App-logo-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.layout {\n  background-color: whitesmoke;\n}\n\n.about {\n  padding-top: 25px;\n  padding-left: 25px;\n}\n\n.about {\n  .line {\n    line-height: 1.5em;\n    .label {\n      font-weight: bold;\n    }\n  }\n}\n\n.logo {\n  padding-top: 1px;\n  padding-bottom: 4px;\n  text-align: center;\n  font-size: 40px;\n  background-image: url(\"./logo_image.jpg\");\n  border-top-style: solid;\n  border-bottom-style: double;\n}\n\n.tutorial h1 {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: 20px;\n  border-top-style: solid;\n  border-bottom-style: double;\n  color: black;\n  text-shadow: -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF;\n}\n\n.tutorial h1 {\n  background-image: url(\"./logo_image.jpg\");\n  background-position: 0px 550px;\n}\n\n.videos {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.videos .header {\n  background-image: url(\"./logo_image.jpg\");\n  background-position: 0px 550px;\n}\n\n.videos a { \n  display: block;\n}\n\n.videos h1 {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: 20px;\n  border-top-style: solid;\n  border-bottom-style: double;\n  color: black;\n  text-shadow: -1px -1px 0 #FFF, 1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px 1px 0 #FFF;\n}\n\n.logo .name {\n  display: inline;\n  padding: 10px;\n  width: 500px;\n  font-weight: bold;\n}\n\n.logo .motto {\n  display: inline;\n  font-size: 5px;\n}\n\n.bar {\n  line-height: 27px;\n  width: 100%;\n}\n\n.barItem {\n  display: inline;\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: rbg(119,119,119);\n  outline-color: rbg(119,119,119);\n  text-decoration-color: rbg(119,119,119);\n}\n\n.barItem:hover {\n  background-color: lightgrey;\n}\n\n.subMenuItem {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  color: rbg(119,119,119);\n  outline-color: rbg(119,119,119);\n  text-decoration-color: rbg(119,119,119);\n}\n\n.subMenuItem:hover {\n  background-color: lightgrey;\n}\n\n.credentials {\n  font-size: 15px;\n  border-style: solid;\n  border-width: 1px;\n  padding: 6px;\n  margin-left: 10px;\n}\n\n.configProps {\n  padding-left: 3px;\n}\n\n#server {\n  width: 200px;\n}\n\n.product {\n  text-align: center;\n}\n\n.product .name {\n  margin-top: 50px;\n  line-height: 45px;\n  font-size: 35px;\n  font-weight: bold;\n}\n\n.product .brief {\n  font-style: italic;\n  font-size: 10px;\n}\n\n.product .details {\n  text-align: center;\n  padding-left: 200px;\n  padding-right: 200px;\n}\n\n.demo {\n  margin-left: 10px;\n}\n\n.product code {\n  font-family: courier;\n  display: block;\n  font-size: 14px;\n  padding-top: 10px;\n  padding-bottom: 5px;\n}\n\ncode {\n  font-family: courier;\n  display: block;\n  padding-left: 100px;\n  display: table;\n}\n\n#contact-form {\n  align: center;\n  float: left;\n  display: inline-block;\n}\n\n#contact-form label {\n  width: 200px;\n}\n\n.form-control {\n  display: inline-block;\n  width: 500px;\n}\n\n.form-control .message {\n  height: 500px;\n}\n\n.quote {\n  font-family: courier;\n  font-size: 15px;\n}\n\npre {\n  margin-left: 100px;\n  margin-right: 100px;\n  background-color: lightgray;\n}\n\n.tutorial {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.purchase {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.purchase p {\n  padding-left: 20px;\n}\n\ntable, th, td {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 20px;\n  border: 1px solid black;\n}\n\n.subscriptions {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.subscriptions .line {\n  margin-top: 10px;\n}\n\n.subscriptions .label {\n  font-weight: bold;\n}\n\n.subscriptions .value {\n  border: 1px solid black;\n  margin-left: 10px;\n  padding: 2px;\n}\n\n.config {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\nform {\n  padding-top: 20px;\n  padding-left: 20px;\n}\n\n.form-group {\n  padding-top: 5px;\n}\n\n.form-control {\n  margin-left: 10px;\n}\n\n.subscriptions .buttons {\n  margin-top: 20px;\n}\n\n.subscriptions .buttons Button {\n  margin-left: 5px;\n}\n\n.menuBar {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.config {\n  margin-top: 20px;\n  padding-left: 20px;\n  font-family: courier, sans-serif;\n  font-size: 15px;\n  white-space: pre;\n}\n\n.controlServer {\n  margin-top: 10px;\n  border-style: solid;\n  padding: 10px;\n}\n\n.productListing {\n  margin-top: 10px;\n  border-style: solid;\n  padding: 5px;\n}\n\n.submitBug {\n  border: 1px solid black;\n}\n\n.moduleSource {\n  border: 1px solid black;\n  font-size: 15px;\n  margin-left: 10px;\n  padding: 5px;\n  padding-bottom: 7px;\n}\n\n.moduleSource a {\n  margin: 5px;\n}\n\n.includes {\n  border-style: solid;\n  border-width: 1px;\n  margin-left: 10px;\n  padding: 5px;\n  padding-bottom: 7px;\n  font-size: 15px;\n}\n\n.includes .selected {\n  margin-left: 5px;\n  font-weight: bold;\n}\n\n.caret {\n  width: 0;\n  height: 0;\n  display: inline-block;\n  border: 10px solid transparent;\n}\n\n.caret.down{\n  border-top-color: black;\n  margin-left: 10px;\n}\n\n.caret.right {\n  border-left-color: black;\n  margin-left: 10px;\n}\n\n.deployVersion button {\n  margin-top: 10px;\n}\n\n.deployVersion a {\n  margin-left: 10px;\n}\n\n.deploymentPaused {\n  margin-left: 10px;\n}\n\n.youtubeLink {\n  margin-left: 10px;\n}\n\n.purchaseVideo a {\n  margin-top: 10px;\n  margin-right: 5px;\n  margin-bottom: 30px;\n}\n\n.arrow {\n  border: solid black;\n  border-width: 0 3px 3px 0;\n  margin-right: 10px;\n  display: inline-block;\n  padding: 3px;\n}\n\n.right {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.left {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n\n.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n\n.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.section {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-weight: bold;\n  font-size: large;\n}\n\n.kms {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.km {\n  padding-left: 20px;\n}\n\n.kmIncludes {\n  margin-left: 40px;\n}\n\n.kmUtterances {\n  margin-left: 40px;\n}\n\n.kmInitial {\n  margin-left: 40px;\n}\n\n.kmName {\n  font-weight: bold;\n}\n\n.footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: lightgreen;\n  color: white;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
